var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "安装"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#安装"
    }
  }, [_vm._v("#")]), _vm._v(" 安装")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("kubectl apply "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-f")]), _vm._v(" https://raw.githubusercontent.com/kubernetes/dashboard/v2.6.1/aio/deploy/recommended.yaml\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "访问控制"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#访问控制"
    }
  }, [_vm._v("#")]), _vm._v(" 访问控制")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("type 修改为 "), _c('code', [_vm._v("NodePort")])]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("kubectl "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-n")]), _vm._v(" kubernetes-dashboard edit svc kubernetes-dashboard\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 然后修改 `type: ClusterIP` 为 `type: NodePort`")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br')])]), _c('p', [_c('img', {
    attrs: {
      "src": require("./02.k8s-dashboard-port.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("查看暴露端口")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_vm._v("kubectl "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-n")]), _vm._v(" kubernetes-dashboard get svc kubernetes-dashboard\nNAME                   TYPE       CLUSTER-IP     EXTERNAL-IP   PORT"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _vm._v("S"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _vm._v("         AGE\nkubernetes-dashboard   NodePort   "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("10.111")]), _vm._v(".81.45   "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("<")]), _vm._v("none"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v(">")]), _vm._v("        "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("443")]), _vm._v(":30629/TCP   5h56m\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 暴露的端口(nodePort)为 30629")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br')])]), _c('p', [_vm._v("通过 "), _c('code', [_vm._v("https://<node-ip>:<nodePort>")]), _vm._v(" 访问 dashboard")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "用户管理"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#用户管理"
    }
  }, [_vm._v("#")]), _vm._v(" 用户管理")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("创建用户")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("mkdir")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-p")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token environment constant"
    }
  }, [_vm._v("$HOME")]), _vm._v("/.kube/dashbaord\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("cat")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("<<")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("EOF"), _c('span', {
    pre: true,
    attrs: {
      "class": "token bash punctuation"
    }
  }, [_vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("tee")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token environment constant"
    }
  }, [_vm._v("$HOME")]), _vm._v("/.kube/dashbaord/admin.yaml")]), _vm._v("\n# kubectl apply -f "), _c('span', {
    pre: true,
    attrs: {
      "class": "token environment constant"
    }
  }, [_vm._v("$HOME")]), _vm._v("/.kube/dashbaord/admin.yaml\napiVersion: v1\nkind: ServiceAccount\nmetadata:\n  name: admin\n  namespace: kubernetes-dashboard\n---\napiVersion: rbac.authorization.k8s.io/v1\nkind: ClusterRoleBinding\nmetadata:\n  name: admin\nroleRef:\n  apiGroup: rbac.authorization.k8s.io\n  kind: ClusterRole\n  name: cluster-admin\nsubjects:\n- kind: ServiceAccount\n  name: admin\n  namespace: kubernetes-dashboard\n\nEOF")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 创建用户")]), _vm._v("\nkubectl apply "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-f")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token environment constant"
    }
  }, [_vm._v("$HOME")]), _vm._v("/.kube/dashbaord/admin.yaml\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("17")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("18")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("19")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("20")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("21")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("22")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("23")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("24")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("25")]), _c('br')])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("创建 token")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 这里其实是返回一个 jwt，如果忘记了可以再次生成")]), _vm._v("\nkubectl "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-n")]), _vm._v(" kubernetes-dashboard create token admin\neyJhbGciOiJSUzI1NiIsImtpZCI6ImhxR1VOeGs2X05CRzhOVkpJbEZZOGtMdWdjRDhCZHktMFhFaXFYRnlrZHMifQ.eyJhdWQiOlsiaHR0cHM6Ly9rdWJlcm5ldGVzLmRlZmF1bHQuc3ZjLmNsdXN0ZXIubG9jYWwiXSwiZXhwIjoxNjYyNzM4MTkyLCJpYXQiOjE2NjI3MzQ1OTIsImlzcyI6Imh0dHBzOi8va3ViZXJuZXRlcy5kZWZhdWx0LnN2Yy5jbHVzdGVyLmxvY2FsIiwia3ViZXJuZXRlcy5pbyI6eyJuYW1lc3BhY2UiOiJrdWJlcm5ldGVzLWRhc2hib2FyZCIsInNlcnZpY2VhY2NvdW50Ijp7Im5hbWUiOiJhZG1pbiIsInVpZCI6ImE0NDU0ZjE5LTEzZjEtNDNlNi05ZDdkLWQ3ZmM2OTMzYTJjNCJ9fSwibmJmIjoxNjYyNzM0NTkyLCJzdWIiOiJzeXN0ZW06c2VydmljZWFjY291bnQ6a3ViZXJuZXRlcy1kYXNoYm9hcmQ6YWRtaW4ifQ.Y2yY-T1wCAGq5dGibQeKr0di2DYFFjnJxurIBhqkqw9x_Bi_tRCoyP9pFNya9NLxcK9mdTPtOKlVdCkK4krdC8dTQ6mNoJ0HVhUj8vLE8CSJTwYztM53UsFNAZFI5gfKssRRm7wbGaMWNpesJHvMA2dNsPZuKUXLFdETl6WhH7pRtoRicU0khFyrFpOQl3bhY6FMk9rAsbZS_tAWLiVbBBNEI6wP787YBwWgIgGYVouV69vvIckXAXZWopCnpyBeLd0hk-Kjb_hss58HPM_sgifDXxWIpRJf9l0q0jUxrO_pbBKF2MLEd3OYChyzhOawp__L_pbEV501hfr5NS9GnQ\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br')])]), _c('p', [_vm._v("浏览器打开（注意是 https） "), _c('code', [_vm._v("https://<node-ip>:<nodePort>")]), _vm._v("，浏览器安全策略会阻止访问，选择继续访问")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./02.k8s-dashboard-login.png"),
      "alt": ""
    }
  }), _vm._v("\n选择 token 登录，从控制台复制生成的 token")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./02.k8s-dashboard.png"),
      "alt": ""
    }
  }), _vm._v("\n登录成功后的界面")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "参考"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#参考"
    }
  }, [_vm._v("#")]), _vm._v(" 参考")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/kubernetes/dashboard",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("github"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/kubernetes/dashboard/blob/master/docs/user/accessing-dashboard/README.md",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("访问控制"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/kubernetes/dashboard/blob/master/docs/user/access-control/creating-sample-user.md",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("用户管理"), _c('OutboundLink')], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };